import React from 'react';
import { Button, Tooltip } from 'antd';
import { CheckOutlined, CopyOutlined, ReloadOutlined, CloseOutlined } from '@ant-design/icons';
import styles from '../../../styles/index.module.scss';

/**
 * 预览结果的操作按钮组：放弃 / 复制 / 重新生成 / 应用
 */
export const PreviewActions = ({
    onCancel,
    onCopy,
    onRegenerate,
    onApply,
    generating = false,
    applying = false,
    applyText = '应用更改',
}) => {
    return (
        <div className={styles.resultActions}>
            <div className={styles.resultActionsSecondary}>
                <Tooltip title="放弃本次结果">
                    <Button icon={<CloseOutlined />} onClick={onCancel} disabled={applying}>
                        放弃
                    </Button>
                </Tooltip>
                {onCopy && (
                    <Tooltip title="复制到剪贴板">
                        <Button icon={<CopyOutlined />} onClick={onCopy} aria-label="复制" />
                    </Tooltip>
                )}
                {onRegenerate && (
                    <Tooltip title="不满意？再生成一次">
                        <Button
                            icon={<ReloadOutlined />}
                            onClick={onRegenerate}
                            disabled={generating || applying}
                            aria-label="重新生成"
                        />
                    </Tooltip>
                )}
            </div>
            <Button
                type="primary"
                icon={<CheckOutlined />}
                onClick={onApply}
                loading={applying}
                disabled={generating}
                className={styles.resultApplyBtn}
            >
                {applyText}
            </Button>
        </div>
    );
};

export default PreviewActions;
